var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "upload") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.039 10.73h-2.609c-0.503 0-0.906 0.402-0.906 0.906s0.402 0.906 0.906 0.906h2.609c1.281 0 2.328 1.046 2.328 2.328v12.999c0 1.281-1.046 2.328-2.328 2.328h-16.085c-1.281 0-2.328-1.046-2.328-2.328v-13.006c0-1.281 1.046-2.328 2.328-2.328h2.609c0.503 0 0.906-0.402 0.906-0.906s-0.402-0.906-0.906-0.906h-2.609c-2.281 0-4.139 1.858-4.139 4.139v12.999c0 2.281 1.858 4.139 4.139 4.139h16.091c2.281 0 4.139-1.858 4.139-4.139v-12.999c-0.007-2.281-1.865-4.132-4.145-4.132zM11.201 6.988l3.89-3.89v14.622c0 0.503 0.402 0.906 0.906 0.906s0.906-0.402 0.906-0.906v-14.622l3.89 3.89c0.174 0.174 0.409 0.268 0.637 0.268s0.463-0.087 0.637-0.268c0.355-0.356 0.355-0.926 0-1.281l-5.44-5.44c-0.355-0.355-0.926-0.355-1.281 0l-5.44 5.44c-0.355 0.356-0.355 0.926 0 1.281 0.369 0.356 0.939 0.356 1.295 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.24401c7c0baf88fe368abfe191e38e91.svg";
export { ForwardRef as ReactComponent };